<template>
  <app-base-main style="padding-top: 12px;" :contentStyle="{'height': '100%'}">
    <template #base-content>
      <app-top-tabs :tabs="tabs" v-model="tabActiveValue" :contentStyle="{'height': '100%'}">
        <template #base>
          <app-head-logistics-base style="height: 100%"></app-head-logistics-base>
        </template>
        <template #duration>
          <app-head-logistics-duration style="height: 100%"></app-head-logistics-duration>
        </template>
      </app-top-tabs>
      <new-user-guide v-if="userGuideState" ref="newUserGuide" ></new-user-guide>
    </template>
  </app-base-main>
</template>

<script>
import {userGuideMixin} from "@/minxins";
import AppHeadLogisticsDuration from "./components/head-logistics-duration";
import AppHeadLogisticsBase from "./components/head-logistics-base";
import NewUserGuide from "./components/new-user-guide"

export default {
  name: "app-head-logistics",
  mixins: [userGuideMixin],
  components: { AppHeadLogisticsBase, AppHeadLogisticsDuration, NewUserGuide },
  data() {
    return {
      tabs: [
        { id: "base", text: "基础信息" },
        { id: "duration", text: "时效看板" },
      ],
      tabActiveValue: 'base',
    };
  },
  provide() {
    return {
      changeTab: (tab)=> {
        this.tabActiveValue = tab
        console.log(this.tabActiveValue)
      },
      nextSteps: (step) => {
        this.userGuideNextStep(step)
      },
      temporarilyClosed:() => {
        this.userGuideTemporarilyClosed()
      },
      cancelUserGuide: () => {
        this.userGuideCancel()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  /deep/ .tabs{
    margin-top: 0;
    width: auto;
    margin-right: 20px;
    font-size: 13px;
  }
</style>
